import React from 'react';
import { Modal, Button, Table, Tag, Spin, Icon, Tooltip,Pagination,Row,Col } from 'antd';
import { openNotification } from '../../../util/notificaciones';
// import Pedidos from '../../services/Pedidos';
import moment from 'moment'
import 'moment/locale/es';
// import PedidosPerfectosRequest from '../../services/ReportePedidosPerfectos';
import ReporteRequest from '../../../services/Reportes';
moment.locale('es')


/**
 * Clase para ver el proceso al planear un pedido
 */
export default class DetalleDiferenciaInventario extends React.Component {
    state = {
        mostrarModalConfirm: false,
        rowDelete: null,
        articulosPedido: [],
        articulosPedidoOriginal: [],
        cargando: false,
        bloquearBtn: false,
        objArticuloCambio: null,
        mostrarModalCambio: false,
        cargandoCambio: false,
        proveedoresAdSitio: [],
        infoTablaCambio: [],
        selectedRowKeys: [],
        selectedRows: [],
        disableBtnCambio: true,
        mostrarConfirmacioneliminar: false,
        articuloCambioSelected: null,
        disableBtnContinuar: false,
        pedido_selected: null,
        bloquearAtras: false,
        objCancelarArticulo: null,
        pedidoModificado: null,
        paginaSiguiente: 1,
        paginacion: {},
        arrResultadoVista: [],
        total:0,
        pageSize:100,
        encabezado:[]
    }

    /**
     * Comportamiento del modal cada vez que se despliega.
     * Se aplica al editar o visualizar datos
     * @param: prevProps. propiedades que tenia el componente antes de ser
     * desplegado
     * @return: nada.
     */
    componentDidUpdate = (prevProps) => {
        let state = { ...this.state }
        if ((this.props.pedido_selected !== prevProps.pedido_selected)) {
            if (this.props.pedido_selected !== null) {
                state.cargando = true;
                this.setState(state, () => {
                        let documento = this.props.pedido_selected.encabezado.Documento;
                        state.encabezado = this.props.pedido_selected.encabezado;
                        ReporteRequest.DiferenciaInventario({documento:[documento]}).then(response => {
                            state.articulosPedido = response.data.resultado.length == 1 ? response.data.resultado[0].detalle : [];
                            const pageSize = state.pageSize;
                            state.total = state.articulosPedido.length;
                            state.arrResultadoVista = state.articulosPedido.filter((item,index)=>{
                                if(pageSize > index){
                                    return true;
                                }})
                            state.cargando = false;
                            this.setState(state)
                        }).catch(err => {
                            console.error('error >>>>>><<',err)
                            openNotification("Ocurrió un error al realizar los filtrados", "Error", false);
                            this.setState({ cargando: false })
                        })
                    })
                    // state.articulosPedido = this.props.pedido_selected.detalle;
                    // const pageSize = state.pageSize;
                    // state.total = state.articulosPedido.length;
                    // state.arrResultadoVista = state.articulosPedido.filter((item,index)=>{
                    //     if(pageSize > index){
                    //         return true;
                    //     }})
                    // state.cargando = false;
                    // this.setState(state);
            }
        }
    }

    /**
     * Función que se manda a llamar cuando se cierra el modal
     * de planeación de un pedido.
     */
    handleCancel = () => {
        let state = { ...this.state }
        state.paginaSiguiente = 1;
        state.encabezado = {};
        this.setState(state)
        this.props.esconderModal(state.pedidoModificado);
    }

    onChangePagination = (page,size) =>{
        let state = { ...this.state };
        const inicio = (page*size) - size;
        const fin =  (page*size);
        state.arrResultadoVista = [];
        state.arrResultadoVista = state.articulosPedido.filter((item,index)=>{
            if(index >= inicio  && index < fin){
                return true;
            }});
        document.getElementsByClassName("ant-modal-wrap ant-modal-centered")[0].scroll(0,0)
        this.setState(state);
    }


    render() {
        const columnasArticulos = [
            {
                title: "Código",
                dataIndex: "Pt",
                key: "Pt",
            },
            {
                title: "Nombre",
                dataIndex: "Nombre",
                key: "Nombre",
            },
            {
                title: "Inventario inicial",
                dataIndex: "InventarioInicial",
                key: "InventarioInicial",
                render: (value, record) => (
                    <div>{record.InventarioInicial.toFixed(3)}</div>
                )
            },
            {
                title: "Remesas",
                dataIndex: "Remesas",
                key: "Remesas",
                render: (value, record) => (
                    <div>{record.Remesas.toFixed(3)}</div>
                )
            },
            {
                title: "Mermas",
                dataIndex: "Mermas",
                key: "Mermas",
                render: (value, record) => (
                    <div>{record.Mermas.toFixed(3)}</div>
                )
            },
            {
                title: "Existencia",
                dataIndex: "Existencia",
                key: "Existencia",
                render: (value, record) => (
                    <div>{record.Existencia.toFixed(3)}</div>
                )
            },
            {
                title: "Unidad",
                dataIndex: "Unidad",
                key: "Unidad",
                 render: (value, record) => (
                    <div>{record.Unidad}</div>
                )
            },
            {
                title: "Conteo",
                dataIndex: "Conteo",
                key: "Conteo",
                render: (value, record) => (
                    <div>{record.Conteo.toFixed(3)}</div>
                )
            },
            {
                title: "Ventas",
                dataIndex: "Ventas",
                key: "Ventas",
                render: (value, record) => (
                    <div>{record.Ventas.toFixed(3)}</div>
                )
            },
            {
                title: "Diferencia",
                dataIndex: "Diferencia",
                key: "Diferencia",
                render: (value, record) => (
                    <div>{record.Diferencia.toFixed(3)}</div>
                )
            },
            {
                title: "Costo diferencia",
                dataIndex: "CostoDiferencia",
                key: "CostoDiferencia",
                render: (value, record) => (
                    <div>{`$${record.CostoDiferencia.toFixed(3)}`}</div>
                )
            },
            {
                title: "Sobrante",
                dataIndex: "Sobrante",
                key: "Sobrante",
                render: (value, record) => (
                    <div>{`$${record.Sobrante.toFixed(3)}`}</div>
                )
            },
            {
                title: "Faltante",
                dataIndex: "Faltante",
                key: "Faltante", 
                render: (value, record) => (
                    <div>{`$${record.Faltante.toFixed(3)}`}</div>
                )
            }
        ]

        return (
            <div>
                <Modal
                    title={this.props.pedido_selected !== null ? "Detalle de inventario: " + this.props.pedido_selected.encabezado.Documento : ""}
                    onCancel={this.handleCancel}
                    visible={this.props.visible}
                    width={"85%"}
                    maskClosable={false}
                    centered={true}
                    footer={
                        [
                            <Button
                                className="btnCancelar"
                                key="back"
                                onClick={this.handleCancel}>
                                Regresar
                            </Button>
                        ]
                    }
                >
                    
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Row gutter={12} >
                            {Object.keys(this.state.encabezado).map((key) => ( 
                                <Col span={6} style={{paddingBottom:'10px'}}>
                                    <div className="center">{key == 'CostoDiferencia' ? 'Costo diferencia' : key}:</div>
                                    <div className="center" style={{fontWeight: '400'}}>{/^[0-9]*-[0-9]*-[0-9]*T[0-9]*:[0-9]*:[0-9]*/.test(this.props.pedido_selected.encabezado[key]) ?  `${this.props.pedido_selected.encabezado[key].substr(8,2)}/${this.props.pedido_selected.encabezado[key].substr(5,2)}/${this.props.pedido_selected.encabezado[key].substr(0,4)} ${this.props.pedido_selected.encabezado[key].substr(11,2)}:${this.props.pedido_selected.encabezado[key].substr(14,2)}` : `${key == 'CostoDiferencia' || key == 'Sobrante' || key == 'Faltante' ? '$' :''}${typeof(this.props.pedido_selected.encabezado[key]) == 'number' ? this.props.pedido_selected.encabezado[key].toFixed(3) : this.props.pedido_selected.encabezado[key]}`}</div>
                                </Col>
                            ))}
                        </Row>
                        <Table
                            size="small"
                            pagination={false}
                            locale={{ emptyText: 'No se han encontrado resultados.' }}
                            rowKey={articulos => articulos.folio}
                            rowClassName={(articulo) => articulo.disabled ? 'back-grey' : ''}
                            columns={columnasArticulos}
                            dataSource={this.state.arrResultadoVista}
                            scroll={this.state.scroll}
                        />
                        <Pagination style={{float:'right'}} defaultCurrent={1} onChange={(page,pageSize) => this.onChangePagination(page,pageSize)} pageSize={this.state.pageSize} total={this.state.total} size={'small'}></Pagination>
                    </Spin>
                </Modal>
            </div>
        )
    }
}